export default __webpack_public_path__ + "static/media/forbidden.15cffd19.svg";